// import { Sun, Moon } from 'lucide-react';

// export default function MobileNav({ darkMode, currentSection, scrollToSection, setDarkMode, mobileMenuOpen, setMobileMenuOpen }) {
//   return (
//     <div
//       className="fixed top-0 left-0 right-0 z-20 lg:hidden"
//       style={{ background: 'var(--navy)', borderBottom: '1px solid rgba(201,168,76,0.2)' }}
//     >
//       <div className="container mx-auto px-4 py-4 flex justify-between items-center">
//         <button
//           onClick={() => scrollToSection('home')}
//           className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center"
//           style={{ border: '2px solid var(--gold)' }}
//         >
//           <img src="images/favicon.png" alt="logo" className="w-full h-full object-cover" />
//         </button>

//         <div className="flex items-center space-x-3">
//           <button
//             onClick={() => setDarkMode(!darkMode)}
//             className="p-2 rounded-lg"
//             style={{ color: 'var(--gold)' }}
//           >
//             {darkMode ? <Sun size={18} /> : <Moon size={18} />}
//           </button>

//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             className="p-2 rounded-lg flex flex-col items-end space-y-1.5"
//           >
//             <span className="block h-0.5 w-6 transition-all" style={{ background: 'var(--gold)' }}></span>
//             <span className="block h-0.5 w-4 transition-all" style={{ background: 'var(--gold)' }}></span>
//             <span className="block h-0.5 w-3 transition-all" style={{ background: 'var(--gold)' }}></span>
//           </button>
//         </div>
//       </div>

//       {mobileMenuOpen && (
//         <div className="absolute top-full left-0 right-0 py-4 px-4 shadow-2xl"
//           style={{ background: 'var(--navy-mid)', borderTop: '1px solid rgba(201,168,76,0.15)' }}>
//           <nav className="flex flex-col space-y-1">
//             {['home', 'about', 'services', 'events', 'contact'].map((item) => (
//               <button
//                 key={item}
//                 onClick={() => scrollToSection(item)}
//                 className="p-3 rounded-lg text-left capitalize text-sm font-medium tracking-wider transition-all"
//                 style={{
//                   color: currentSection === item ? 'var(--gold)' : 'var(--slate)',
//                   background: currentSection === item ? 'rgba(201,168,76,0.1)' : 'transparent',
//                   letterSpacing: '0.08em',
//                 }}
//               >
//                 {item}
//               </button>
//             ))}
//           </nav>
//         </div>
//       )}
//     </div>
//   );
// }

import { Sun, Moon, Menu, X } from 'lucide-react';

export default function MobileNav({
  darkMode,
  currentSection,
  scrollToSection,
  setDarkMode,
  mobileMenuOpen,
  setMobileMenuOpen,
}) {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-20 lg:hidden"
      style={{
        background: '#0B1220', // solid dark navy
        borderBottom: '1px solid rgba(201,168,76,0.35)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
      }}
    >
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        
        {/* Logo */}
        <button
          onClick={() => scrollToSection('home')}
          className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center"
          style={{ border: '2px solid #C9A84C' }}
        >
          <img
            src="images/favicon.png"
            alt="logo"
            className="w-full h-full object-cover"
          />
        </button>

        {/* Right Side */}
        <div className="flex items-center space-x-3">
          
          {/* Dark Mode Toggle */}
          <button
            onClick={() => setDarkMode(!darkMode)}
            className="p-2 rounded-lg transition-all hover:bg-[#C9A84C]/10"
            style={{ color: '#C9A84C' }}
          >
            {darkMode ? <Sun size={18} /> : <Moon size={18} />}
          </button>

          {/* Hamburger / Close */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 rounded-lg transition-all hover:bg-[#C9A84C]/10"
            style={{ color: '#C9A84C' }}
          >
            {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div
          className="absolute top-full left-0 right-0 py-4 px-4"
          style={{
            background: '#0D1525', // solid, no transparency
            borderTop: '1px solid rgba(201,168,76,0.3)',
            boxShadow: '0 10px 40px rgba(0,0,0,0.6)',
          }}
        >
          <nav className="flex flex-col space-y-2">
            {['home', 'about', 'services', 'events', 'contact'].map((item) => (
              <button
                key={item}
                onClick={() => {
                  scrollToSection(item);
                  setMobileMenuOpen(false);
                }}
                className="p-3 rounded-lg text-left capitalize text-sm font-medium tracking-wider transition-all duration-200 hover:bg-[#C9A84C]/10"
                style={{
                  color:
                    currentSection === item ? '#C9A84C' : '#cbd5e1',
                  background:
                    currentSection === item
                      ? 'rgba(201,168,76,0.15)'
                      : 'transparent',
                }}
              >
                {item}
              </button>
            ))}
          </nav>
        </div>
      )}
    </div>
  );
}